// extracted by mini-css-extract-plugin
export default {"badge":"WTrcomAZ","neutral":"NNyQLq6m","positive":"eiOnoiFa","alert":"RiSEKYkd","warning":"M2eG0HwB","attention":"w1XZI1Fi","success":"L5oYdTvv"};